

import React, { Component  } from "react"
import "../css/Camara.css"
import axios from 'axios';
import equis from "../assets/eliminar.svg"
import { Spinner } from 'react-bootstrap';


class camara extends Component {

    constructor(props) {
        super(props);

        this.state = {
            imgSrc: "",
            showImg: false,
            showerr: false,
            loading: false,

        }
        this.captureImage = this.captureImage.bind(this);
        this.Volver = this.Volver.bind(this);
        this.Guardar = this.Guardar.bind(this);
        this.setonloading = this.setonloading.bind(this);
        this.setoffloading = this.setoffloading.bind(this);
    }


    setonloading() {
        this.setState({ loading: true });
    }


    setoffloading() {
        this.setState({ loading: false });
    }

    componentDidMount() {
        this.getStream().then(this.getDevices).then(this.gotDevices)
    }

    componentDidUpdate() {
        if (!this.state.showImg && !this.state.showerr) {

            this.getStream().then(this.getDevices).then(this.gotDevices)
        }
    }

    getDevices = async () => {
        return await navigator.mediaDevices.enumerateDevices();
    }

    gotDevices(deviceInfos) {
        var videoSelect = document.getElementById('videoSource');
        try {
            window.deviceInfos = deviceInfos; // make available to console
            //console.log('Available input and output devices:', deviceInfos);
            for (const deviceInfo of deviceInfos) {
                const option = document.createElement('option');
                option.value = deviceInfo.deviceId;
                if (deviceInfo.kind == 'videoinput') {
                    option.text = deviceInfo.label || `Camera ${videoSelect.length + 1}`;
                    videoSelect.appendChild(option);


                }
            }
        } catch (error) {
            //console.log(error);

        }
  
    }

    getStream() {
      
            var videoSelect = document.getElementById('videoSource');
            if (window.stream) {
                window.stream.getTracks().forEach(track => {
                    track.stop();
                });
            }
            const videoSource = videoSelect.value;
            const constraints = {
                video: { deviceId: videoSource ? { exact: videoSource } : undefined }
            };
            return navigator.mediaDevices.getUserMedia(constraints).
                then(this.gotStream).catch(this.handleError);
      
       
    }

    gotStream(stream) {
        try {
            var videoSelect = document.getElementById('videoSource');
            var videoElement = document.getElementById('videoCam')

            window.stream = stream; // make stream available to console
            videoSelect.selectedIndex = [...videoSelect.options].
                findIndex(option => option.text == stream.getVideoTracks()[0].label);
            videoElement.srcObject = stream;
        } catch (error) {
            //console.log(error);
        }

       

    }

    handleError(error) {
        console.error('Error: ', error);
    }

    captureImage() {

        var videoElement = document.getElementById('videoCam')
        let canvas = document.createElement('canvas');

        canvas.width = 1920;
        canvas.height = 1080;
        let ctx = canvas.getContext('2d');
        ctx.drawImage(videoElement, 0, 0, canvas.width, canvas.height);
        let image = canvas.toDataURL('image/jpeg');
        this.setState({ imgSrc: image })
        this.setState({ showImg: true })
        this.setState({ showerr: false })
        //this.setState({ showImg: true })
    }

    Volver() {
        this.setState({ showImg: false });
        this.setState({ setshowerr: false });
    }

    Guardar() {
        this.setonloading();
        var solicitud = {
            foto: this.state.imgSrc,
        }

        axios.post(`${process.env.REACT_APP_API}api/Solicitud/imagen/rostro`, solicitud).then(res => {
            if (res.status == 200) {
                this.props.imgRostro(this.state.imgSrc);
                this.setoffloading();

            }
        }).catch(error => {

            this.setState({ imgSrc: null })
            this.setState({ showImg: false })
            this.setState({ showerr: true })
            this.setoffloading();

            //this.props.imgRostro(this.state.imgSrc);
            //this.setState({ imgSrc: image })
            //this.setState({ showImg: true })
        })

        //this.setState({ showImg: false })
        //this.setState({ setshowerr: false })
        //
    }

    
  

    render() {
        return (

            this.state.showImg && !this.state.showerr ?
                <div >
                    <div className='mt-4 camara-webcam'>
                        <h4 className='text-center'><strong>Foto Tomada</strong></h4>
                        <div align="center "><img className="camara-img-dim mb-2" src={this.state.imgSrc} /></div>
                        <div className='text-center'><p > ¿Está de acuerdo con la fotografía tomada?</p></div>
                        <div className='camara-container-btnModal'>
                            <div className="row justify-content-evenly">
                                <div className="col-5 col-sm-5">
                                    <button onClick={this.Volver} className='camara-btnModal-img'>Volver</button>
                                </div>
                                <div className="col-5 col-sm-5">
                                    <button onClick={this.Guardar} className='camara-btnModal-img'>Guardar</button>
                                </div>
                            </div>
                        </div>
                        {this.state.loading ?
                            <div className="row spinner-display" align="center">
                                <div className="col-12 col-lg-12 col-xl-12" >
                                    <div className="col-12 col-lg-6 col-xl-6">
                                        <Spinner animation="border" variant="primary" ></Spinner>

                                    </div>
                                    <div className="col-12 col-lg-6 col-xl-6" >
                                        <span className='spinner-loading'>Cargando...</span>

                                    </div>
                                </div>
                            </div>
                            : <div className="row spinner-display-none" align="center">
                                <div className="col-12 col-lg-12 col-xl-12" >
                                    <div className="col-12 col-lg-6 col-xl-6">
                                        <Spinner animation="border" variant="primary" ></Spinner>


                                    </div>
                                    <div className="col-12 col-lg-6 col-xl-6" >
                                        <span >Cargando...</span>

                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
                : !this.state.showImg && !this.state.showerr ?
                    <div >

                    <div className='mt-4 camara-webcam'>
                        <h4 className='text-center'><strong>Foto del Rostro</strong></h4>

                            <div className="select">
                                <label htmlFor="videoSource">Video source: </label>
                                <select id="videoSource"
                                    onChange={() => this.getStream()}
                                >
                                </select>
                            </div>

                            <video id="videoCam" autoPlay muted playsInline></video>

                        <div className='text-center'><p >*Procure tomar la fotografia en un lugar iluminado</p></div>

                        <div className='camara-container-btnModal'>
                            <button onClick={this.captureImage} className='camara-btnModal'>Tomar Foto</button>
                        </div>
                    </div>
                </div>

                :!this.state.showImg && this.state.showerr ?
                    <div>
                        <p className='text-center'><strong>Error en la Solicitud</strong></p>
                        <div className='mt-2 mb-3' align="center">
                            <img className="camara-equis" src={equis} alt="Error"></img>
                        </div>
                        <p className='camara-padd text-center'> La fotografia tomada no es aceptable, procure que se vea el rostro completo.</p>
                    </div> : null

           
        )
    }

}

export default camara;




